import { render, staticRenderFns } from "./AddCollaborators.vue?vue&type=template&id=5ecafd3e&scoped=true&"
import script from "./AddCollaborators.vue?vue&type=script&lang=js&"
export * from "./AddCollaborators.vue?vue&type=script&lang=js&"
import style0 from "./AddCollaborators.vue?vue&type=style&index=0&id=5ecafd3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecafd3e",
  null
  
)

export default component.exports